/* Repeats only the visual strip; the original messages remain the sole accessible set. */
(() => {
  if (customElements.get('modello-announcement-marquee')) return;
  class ModelloAnnouncementMarquee extends HTMLElement {
    #observer;
    #frame = 0;
    #key = '';
    #motion;
    #button;
    #viewport;
    #track;
    #source;
    connectedCallback() {
      this.#viewport = this.querySelector('.mam__viewport');
      this.#track = this.querySelector('.mam__track');
      this.#source = this.querySelector('[data-mam-source]');
      this.#button = this.querySelector('.mam__control');
      if (!this.#viewport || !this.#track || !this.#source || !this.#source.children.length) return;
      this.#motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.#motion.addEventListener('change', this.#schedule);
      this.#button?.addEventListener('click', this.#toggle);
      this.#observer = new ResizeObserver(this.#schedule);
      this.#observer.observe(this.#viewport);
      this.#observer.observe(this.#source);
      this.#schedule();
    }
    disconnectedCallback() {
      this.#observer?.disconnect();
      this.#motion?.removeEventListener('change', this.#schedule);
      this.#button?.removeEventListener('click', this.#toggle);
      cancelAnimationFrame(this.#frame);
    }
    #schedule = () => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(this.#refresh);
    };
    #refresh = () => {
      const width = this.#source.getBoundingClientRect().width;
      const viewport = this.#viewport.clientWidth;
      if (width <= 0 || viewport <= 0) return;
      const reduced = this.#motion.matches;
      const key = `${width}:${viewport}:${reduced}`;
      if (key === this.#key) return;
      this.#key = key;
      for (const copy of this.#track.querySelectorAll('[data-mam-copy]')) copy.remove();
      if (!reduced) {
        const copies = Math.ceil(viewport / width);
        for (let i = 0; i < copies; i++) {
          const copy = this.#source.cloneNode(true);
          copy.removeAttribute('data-mam-source');
          copy.setAttribute('data-mam-copy', '');
          copy.setAttribute('aria-hidden', 'true');
          for (const item of [copy, ...copy.querySelectorAll('*')]) {
            item.removeAttribute('id');
            item.removeAttribute('data-shopify-editor-block');
            if (item.matches('a, button, input, select, textarea, [tabindex]')) item.setAttribute('tabindex', '-1');
          }
          this.#track.appendChild(copy);
        }
      }
      const speed = Math.min(60, Math.max(15, Number(this.dataset.speed) || 28));
      this.style.setProperty('--mam-distance', `${width}px`);
      this.style.setProperty('--mam-duration', `${width / speed}s`);
      this.toggleAttribute('data-ready', !reduced);
      if (this.#button) this.#button.hidden = reduced;
    };
    #toggle = () => {
      const paused = this.toggleAttribute('data-paused');
      this.#button.setAttribute('aria-pressed', String(paused));
      this.#button.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
    };
  }
  customElements.define('modello-announcement-marquee', ModelloAnnouncementMarquee);
})();
